import {
  OreCardContainer,
  OreCardWrapper,
  OreDivider,
  OreHeading,
  OreStack,
  OreText
} from '@edenredespana/oreneta'
import { Trans, useTranslation } from 'react-i18next'

import { AutoEnrollmentDefaultConditionsModel } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'

interface ContractNewProductsStep1ProductWrapperProps {
  children: JSX.Element
  product: AutoEnrollmentDefaultConditionsModel
}

export const ContractNewProductsStep1ProductWrapper = ({
  children,
  product,
}: ContractNewProductsStep1ProductWrapperProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <OreStack direction="column" space="large" placeContent="stretch">
      <OreCardContainer tone="neutral-100" >
        <OreCardWrapper>
          <OreStack direction="column" space="large" placeContent="stretch">
            <OreStack direction="row" placeContent="space-between">
              <OreHeading
                size="headline-lg"
                tone="neutral"
              >
                {product.productName}
              </OreHeading>
            </OreStack>
            {product.productCode === 33 ? <OreText tone="neutral-500">
               <Trans t={t}>
                {t(AutoEnrollmentTranslation.premiumLegend)}
               </Trans>
            </OreText> : null}
            {children}
          </OreStack>
        </OreCardWrapper>
      </OreCardContainer>
      <OreDivider space="medium" />
    </OreStack>
  )
}
